/**
 * ErrorBoundary — локальная защита тяжёлых сторонних виджетов (Spline 3D).
 * Если виджет упал (нет WebGL, сцена недоступна, runtime-сбой) — секция
 * не белеет, а показывает заданный fallback. React-boundary обязан быть
 * классовым компонентом.
 */
import { Component, type ReactNode } from "react";

interface ErrorBoundaryProps {
  fallback: ReactNode;
  children: ReactNode;
  onError?: (error: Error) => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    this.props.onError?.(error);
  }

  render(): ReactNode {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}
